import { registerPlugin } from '@capacitor/core';
import { SplashScreenWeb } from '@capacitor/splash-screen/dist/esm/web';
const SplashScreen = registerPlugin('SplashScreen', {
    web: () => new SplashScreenWeb()
});
export { SplashScreen };
